export default () => ({
	S_TYPE_WEIGHT_OPTIONS: [],
	S_SPECIMEN_TRACKING_WEIGHTS: [],
	S_MASSIVELY_WEIGHTS: [],
	S_IS_TRAINING: false,
})
